import { copySurveyAndCreateNew, deleteSurvey, exportToCsv, getSelectorsData } from "../api/surveyAPI";
import { SurveyEndRequestDto, SurveyListActions, SurveyListDto, UseGetReasonsClosedObjectResult } from "../types";
import { useTranslation } from "react-i18next";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { formatDateDisplay } from '../../../../utils/dateUtils';
import { SurveyListPagination } from "../types";
import { useModal } from "../../../../hooks/useModal";
import ModalGlobal from "../../../../components/AppModal/ModalGlobal";
import { RouteNavigationService } from "../../../../utils/navegation/RouteNavegationService";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useGetReasonsClosed } from "../hooks/useGetReasonsClosed";
import { ApiErrorResponse } from "../../../../types/ApiErrorResponse";
import AppTable, { ColumnConfig } from "../../../../components/AppTable/AppTable";
import { SectionPermissionTypeEnum } from "../../../../types/SectionPermissionTypesEnum";
import { Col, Form, Row } from "react-bootstrap";
import { SelectItemDto } from "../../../../types/SelectItemDto";

interface SurveyListTableProps {
    surveyData: SurveyListPagination;
    totalPages: number;
    currentPage: number;
    selectorType?: string;
    pageSize: number;
    setMessage: (value: string) => void;
    fetchSurveys: () => void;
    surveyListActions: SurveyListActions;
}

export default function SurveyListTable({ surveyData, totalPages, currentPage, pageSize, surveyListActions, fetchSurveys }: SurveyListTableProps) {

    const { t } = useTranslation('surveyAdmin');

    const navigate = useNavigate();
    const navigationService = new RouteNavigationService(navigate);
    //recogida campa�as para modal
    const { reasonClosedData, fetchReasonClosedData } = useGetReasonsClosed();
    const handleExportCsv = async () => {
        try {

            await exportToCsv();
        } catch (err) {
            const fetchError = err as ApiErrorResponse;
            navigationService.navigateWithMessage(
                '/admin/surveyList',
                fetchError.message
            );
        }
    }

    const handleView = async (surveyId: number) => {
        navigate(`/admin/surveyList/${surveyId}`)
    };

    const [showCopyModal, setShowCopyModal] = useState(false);
    const [copySourceSurvey, setCopySourceSurvey] = useState<SurveyListDto | null>(null);
    const [copySurveyName, setCopySurveyName] = useState("");
    const [selectedCopyCampaignId, setSelectedCopyCampaignId] = useState<number | null>(null);
    const [copyGeneralData, setCopyGeneralData] = useState(false);
    const [copyQuestions, setCopyQuestions] = useState(false);
    const [copyParticipants, setCopyParticipants] = useState(false);
    const [copyCampaignOptions, setCopyCampaignOptions] = useState<SelectItemDto[]>([]);
    const [copyModalError, setCopyModalError] = useState("");
    const [isCopyLoading, setIsCopyLoading] = useState(false);

    const handleCopy = async (survey: SurveyListDto) => {
        setCopySourceSurvey(survey);
        setCopySurveyName(`${survey.surveyName} - Copy`);
        setSelectedCopyCampaignId(null);
        setCopyGeneralData(false);
        setCopyQuestions(false);
        setCopyParticipants(false);
        setCopyModalError("");
        if (copyCampaignOptions.length === 0) {
            try {
                const selectors = await getSelectorsData();
                setCopyCampaignOptions(selectors.campaings ?? []);
            } catch (error) {
                const fetchError = error as ApiErrorResponse;
                setCopyModalError(fetchError.message);
            }
        }
        setShowCopyModal(true);
    };

    const { showModal, closeModal, modalData, errorModal, isLoading, openModal, setEndDate, currentItem, endDate } = useModal<SurveyListDto>();

    const handleSaveModal = async () => {
        if (modalData.type === 'end' && endDate) {

            const body: SurveyEndRequestDto = {
                endDate: endDate,
                surveyClosedReasonId: surveyClosedReasonId
            };

            await surveyListActions.onEnd(currentItem!.id, body);

            navigationService.navigateWithMessage('/admin/surveyList', t("surveyAdmin:modal.modalEndSurveySuccessMissatge"));
            await fetchSurveys();
            closeModal();
        }
        if (modalData.type === 'deleteWithoutInput') {
            try {
                await deleteSurvey(currentItem?.id ?? 0);
                await fetchSurveys();
                closeModal();
                navigationService.navigateWithMessage('/admin/surveyList', t("surveyAdmin:modal.modalDeleteSurveySuccessMissatge"));

            } catch (error) {
                const fetchError = error as ApiErrorResponse;
                navigationService.navigateWithMessage(
                    '/admin/surveyList',
                    fetchError.message
                );
            }
        }
    };


    const onEndDateChange = (date: Date | null) => {
        setEndDate(date)
    };
    const [surveyClosedReasonId, setSurveyClosedReasonId] = useState<number | null>();

    const handleSelectChange = (value: string | null) => {
        setSurveyClosedReasonId(Number(value));
    };

    const handleOpenEndModal = async (data: SurveyListDto) => {
        await fetchReasonClosedData();
        openModal(data, t('surveyAdmin:modal.modalEndSurveyLoadTitle'), t('surveyAdmin:modal.modalEndSurveyLoadSubtitle', { nameSurvey: data.surveyName }), 'end', t('surveyAdmin:modal.modalEndSurveyLoadSubtitle2'));
    };


    const handleCopySurvey = async () => {
        
        if (!copySourceSurvey) return;
        if (!copySurveyName.trim()) {
            setCopyModalError(t("common:form.requiredFieldForm"));
            return;
        }
        if (!selectedCopyCampaignId) {
            setCopyModalError(t("surveyAdmin:form.errors.campaignRequired"));
            return;
        }

        setCopyModalError("");
        setIsCopyLoading(true);
        try {
            await copySurveyAndCreateNew({
                idOriginalSurvey: copySourceSurvey.id,
                newSurveyName: copySurveyName,
                idNewSurveyCampaign: selectedCopyCampaignId,
                copyGeneralData,
                copyQuestions,
                copyParticipants
            });
            setShowCopyModal(false);
            await fetchSurveys();
        } catch (error) {
            const fetchError = error as ApiErrorResponse;
            setCopyModalError(fetchError.message);
        } finally {
            setIsCopyLoading(false);
        }
    }

    const columns: ColumnConfig<SurveyListDto>[] = [
        { header: t("surveyAdmin:headerTableSurvey1"), key: "id", render: (item) => <>{item.id}</> },
        { header: t("surveyAdmin:headerTableSurvey2"), key: "surveyName" },
        { header: t("surveyAdmin:headerTableSurvey3"), key: "campaign" },
        { header: t("surveyAdmin:headerTableSurvey4"), key: "status", render: (item) => item.status ? t(`surveyAdmin:status.${item.status}`) : '' },
        { header: t("surveyAdmin:headerTableSurvey5"), key: "adherence" },
        { header: t("surveyAdmin:headerTableSurvey6"), key: "validityStartDate", render: (item) => item.startDate ? formatDateDisplay(item.startDate.toString()) : '' },
        { header: t("surveyAdmin:headerTableSurvey7"), key: "validityEndDate", render: (item) => item.endDate ? formatDateDisplay(item.endDate.toString()) : '' },
    ];

    return (
        <div>
            <ModalGlobal<UseGetReasonsClosedObjectResult>
                show={showModal}
                onClose={closeModal}
                title={modalData.title}
                contentType={modalData.type}
                subtitle={modalData.subtitle}
                subtitle2={modalData.subtitle2}
                saveText={t("common:modalActionOK")}
                closeText={t("common:modalActionNOTOK")}
                error={errorModal?.endDate || errorModal?.errorModal}
                endDate={endDate}
                optionsMap={reasonClosedData}
                showOptions = {true}
                onEndDateChange={onEndDateChange}
                handleSelectChange={handleSelectChange}
                onSave={() => handleSaveModal()}
                isLoading={isLoading}
            />
            <ModalGlobal
                show={showCopyModal}
                onClose={() => {
                    setShowCopyModal(false);
                    setCopyModalError("");
                }}
                title={t("surveyAdmin:copyModal.title", { description: copySourceSurvey?.surveyName ?? "" })}
                body={<>
                    <Row>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>{t("surveyAdmin:copyModal.targetSurveyName")}</Form.Label>
                                <Form.Control
                                    value={copySurveyName}
                                    onChange={(event) => setCopySurveyName(event.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>{t("surveyAdmin:copyModal.targetCampaign")}</Form.Label>
                                <Form.Select
                                    value={selectedCopyCampaignId ?? ""}
                                    onChange={(event) => setSelectedCopyCampaignId(event.target.value ? Number(event.target.value) : null)}
                                >
                                    <option value="">{t("common:selectDefaultText")}</option>
                                    {copyCampaignOptions.map((campaign) => (
                                        <option key={campaign.id} value={campaign.id}>
                                            {campaign.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={12} className="mt-3">
                            <Form.Check
                                type="checkbox"
                                label={t("surveyAdmin:copyModal.copyGeneralData")}
                                checked={copyGeneralData}
                                onChange={(event) => setCopyGeneralData(event.target.checked)}
                            />
                            <Form.Check
                                type="checkbox"
                                label={t("surveyAdmin:copyModal.copyQuestions")}
                                checked={copyQuestions}
                                onChange={(event) => setCopyQuestions(event.target.checked)}
                            />
                            <Form.Check
                                type="checkbox"
                                label={t("surveyAdmin:copyModal.copyParticipants")}
                                checked={copyParticipants}
                                onChange={(event) => setCopyParticipants(event.target.checked)}
                            />
                        </Col>
                        {copyModalError && (
                            <Col md={12} className="mt-2">
                                <small className="text-danger">{copyModalError}</small>
                            </Col>
                        )}
                    </Row>
                </>}
                closeText={t("common:buttons.buttonClose")}
                saveText={t("surveyAdmin:copyModal.saveButton")}
                isLoading={false}
                onSave={handleCopySurvey}
            />
            <AppTable<SurveyListDto>
                data={surveyData.items || []}
                columns={columns}
                emptyMessage={t("nonregistersSurvey")}
                t={t}
                hasActions={true}
                onDelete={(item) => openModal(item, t('surveyAdmin:modal.modalDeleteSurveyLoadTitle'), t('surveyAdmin:modal.modalDeleteSurveyLoadSubtitle', { nameSurvey: item.surveyName }), 'deleteWithoutInput', "")}
                onView={handleView}
                onEnd={handleOpenEndModal}
                onCopy={handleCopy}
                hasPagination={true}
                currentPage={currentPage}
                totalPages={totalPages}
                pageSize={pageSize}
                paginationType="adminSurveys"
                onExportCsv={handleExportCsv}
                sectionPermission={SectionPermissionTypeEnum.SURVEYS}
            />
        </div >
    );
}


